// Mirror of the Dr.-Hoffmann-related services configured on the shared
// backend (see `Tawan Spa/server/utils/massages.js`). Prices are in cents.

export const DR_HOFFMANN_SERVICES = [
  {
    key: "dr-hoffmann-consultation",
    label: "Lizenzpartner Erstbesuch",
    category: "Dr. Hoffmann · Lizenz",
    description:
      "Kostenloses Vor-Ort-Erstgespräch inkl. bis zu 6 Test-Massagen und Location-Check.",
    durations: [{ minutes: 30, priceCents: 0 }],
    requiresLogin: false,
    paymentDefault: "later",
    locationDefault: "Vor Ort beim Lizenzpartner",
  },
  {
    key: "dr-hoffmann-studio",
    label: "Dr. Hoffmann Massage im Studio",
    category: "Dr. Hoffmann · Studio",
    description:
      "10-Minuten Perkussiv-Massage im Studio (aktuell Tavon Spa, Hopfenmarkt 31). Bezahlung vor Ort.",
    durations: [{ minutes: 10, priceCents: 2900 }],
    requiresLogin: true,
    paymentDefault: "on-site",
    locationDefault: "Tavon Spa · Hopfenmarkt 31, 20457 Hamburg",
  },
  {
    key: "dr-hoffmann-mobile",
    label: "Dr. Hoffmann Massage Vor Ort",
    category: "Dr. Hoffmann · Mobil",
    description:
      "10-Minuten Perkussiv-Massage bei Ihnen vor Ort (Büro, Event, Zuhause). Nur im Hamburger Stadtgebiet.",
    durations: [{ minutes: 10, priceCents: 3900 }],
    requiresLogin: true,
    requiresAddress: true,
    paymentDefault: "stripe",
    locationDefault: null,
  },
];

export const findService = (serviceKey, durationMinutes) => {
  const service = DR_HOFFMANN_SERVICES.find((s) => s.key === serviceKey);
  if (!service) return null;
  const duration = service.durations.find(
    (d) => Number(d.minutes) === Number(durationMinutes)
  );
  if (!duration) return null;
  return { service, duration };
};

export const formatPrice = (cents) =>
  (cents / 100).toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
  });
